<template>
  <div :class="cardClasses">
    <CCard @click="sendCoord(item)" class="card-detail-rent" body-wrapper>
    
      
      <img
          class="float-left mr-4"
          :style="{ width: '200px', height: '200px' }"
          :src="image != null ? image.url : require('@/assets/img/no-image.jpg')"
        />


      <div class="description">
        <div
          class="ml-4 justify-content-between pt-2 align-items-center mt-2 mb-1"
        >
            <span class="d-flex justify-content-between" >
                
              <h5 class="text-primary">{{ item.name }}</h5>

              <span @click="openMaps()" class="text-primary" v-c-tooltip.hover="`Abrir en maps`" >
                <CIcon height="30" name="cil-location-pin"/>
              </span>

            <!-- <span class="text-muted mr-4">
               <CIcon height="30" :src="require('@/assets/img/marker.svg')"/>
              {{ item.total_spots }} plazas
            </span> -->
            </span>

              <p class="text-black-50"> 
                <!-- <CButton @click="openMaps()" style="border: none;" color="primary" size="sm" variant="outline">
                <CIcon v-c-tooltip="`Abrir en maps`" name="cil-map"/> 
                </CButton> -->
                {{item.address}}
              </p>

              <p class="text-black-70 mt-0" v-if="item.town" >{{item.town.name}}</p>

        </div>

        <!-- <div class="ml-4 text-center mb-2">
          <strong>Desde {{ price }} € </strong>
          <span class="mt-0 text-black-50"> el {{ plan ? plan : 'plan'}}</span>
        </div> -->

        <div class="ml-4 d-flex justify-content-between align-items-center">
          <semaforo :ocupation="getOcupation"/>
          <!-- <span class="text-muted mr-4">
            <CIcon height="22" :src="require('@/assets/img/moto.svg')"/>
            {{ item.total_spots }} plazas
          </span> -->
        </div>

      </div>
      <!-- <div class="align-items-center"> -->
        
        <!-- <CIcon
          v-for="(plan, index) in item.plans"
          size="lg"
          v-c-tooltip="`${plan.plan.name}`"
          :style="'margin: 4px'"
          :key="index"
          :name="getIcon(plan)"
        ></CIcon> -->
      <!-- </div> -->
      <div class="d-flex mb-2 goToDetail" :style="'float: right;'">
        <CButton
          class="mr-2"
          style="width: 100px"
          @click="goToDetail"
          color="outline-dark"
          shape="pill"
          >Tarifas</CButton
        >
      </div>



    </CCard>
  </div>
</template>

<script>
import { openGoogleMaps } from '@/app/shared/utils/utils';
import semaforo from '@/app/shared/components/Semaforo';

import { fetchOneParkingImage } from '@/app/shared/global/services/parking-service';

export default {
  name: "ParkingCard",
  components:{semaforo},
  props: {
    item: { type: Object, default: {} },
    cardClasses: { type: String, default: "" },
  },
  data() {
    return {
      price: 0,
      plan: "",

      image: null, // "@/assets/img/no-image.jpg"
    };
  },
  mounted() {
    this.getPrice();
    // this.getImage();

    if (this.item) {
      this.getParkingImage(this.item.id);
    }
  },
  computed: {

    getOcupation() {

      // const data = ['ALTA','BAJA','MEDIA'];
      // const MIN=0;
      // const MAX=2;
      // const index = Math.floor(Math.random() * ((data.length-1) - MIN + 1)) + MIN;
      // return data[index].toLowerCase();

      return this.item.status_occupation.toLowerCase();
    },
    getImg() {
      let img = null;
      if (this.item.images && this.item.images.length > 0) {
        this.image = this.item.images.find((i) => i.is_main);
        img = this.item.images.find((i) => i.is_main);
      }

      return img;
    }
  },
  methods: {

    async getParkingImage(parkingId) {

      try {
        let resp = await fetchOneParkingImage(parkingId);
        if (resp.status !== "success") {
          return;
        }

        let images = resp.data;
        
        if (images) {

          this.image = images;
          //  this.image.url = 'https://api.mimotov2.trestristestigres.com/api/base/parkings-images/5/1yit7eysltch2lbp9ovbozaivaouui08lpsrgcwh.jpeg';
        };

      } catch (e) {
        this.image = null;
        // console.error(e);
      }
    
    },

    openMaps() {
      openGoogleMaps(this.item);
    },
    getIcon(plan) {
      return plan.plan.id == 2
        ? "cil-chart-pie"
        : plan.plan.id == 1
        ? "cil-clock"
        : // : plan.plan.name == "Periodo de prueba"
        // ? "cil-gift"
        // : plan.plan.name == "Plan Personalizados"
        // ? "cil-asterisk-circle"
        plan.plan.id == 3
        ? "cil-bed"
        : plan.plan.id == 4
        ? "cil-history"
        : plan.plan.id == 10
        ? "cil-calendar"
        : plan.plan.id == 6
        ? "cil-calendar-check"
        : plan.plan.id == 7
        ? "cil-briefcase"
        : plan.plan.id == 8
        ? "cil-balance-scale"
        : plan.plan.id == 5
        ? "cil-av-timer"
        : plan.plan.id == 9
        ? "cil-moon"
        : "cil-asterisk-circle";
    },
    getImage() {
      if (this.item.images && this.item.images.length > 0) {
        this.image = this.item.images.find((i) => i.is_main);
      }
    },
    getPrice() {
      if (this.item.plans && this.item.plans.length > 1) {
        const defaultPrice = this.item.plans.find(
          (p) => p.active && p.plan.name != "Plan Base"
        );

        if (defaultPrice == null) {
          const planBase = this.item.plans.find(
            (p) => p.plan.name == "Plan Base"
          );
          this.price = planBase.price_per_minute / 100;
          this.plan = "Plan Base (por minuto)";
        } else {
          this.item.plans.forEach((p) => {
            if (p.active && defaultPrice.amount >= this.getDailyPrice(p)) {
              this.price = p.amount;
              this.plan = p.plan.name;
            }
          });
        }
      }
    },
    getDailyPrice(plan) {
      if (plan.plan.id != 3 && plan.plan.id != 9)
        return plan.amount / plan.plan.plan_detail.duration;
      else return plan.amount;
    },
    goToDetail() {
      this.$router.push({ path: `/parkings/${this.item.id}` });
    },
    sendCoord(item) {
      const coords = { lat: item.latitude, lng: item.longitude };
      this.$emit("sendCoords", coords);
    },
  },
};
</script>

<style lang ="scss" scoped>
.card {
  transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.1s box-shadow,
    0.1s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
  /* padding: 14px 80px 18px 36px; */
  cursor: pointer;
}

.card:hover {
  transform: scale(1.01);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06);
}
.card-body {
  padding: 0px;
  padding-right: 1.25rem;
}

@media screen and (max-width: 768px) {

  img {
    /* float: none !important;
    width: 100% !important;
    height: 250px !important;
    margin-right: 0px !important;
    margin-bottom: 4px !important; */
    display: none;
  }
  /* div {
    margin-left: 2px !important;
  } */
  .cardClasses {
    height: 75% !important;
  }
  .card-body {
    padding-right: 0px !important;
  }
  .description {
    /* text-align: center; */
    /* position: relative; */
  }
  .goToDetail {
    display: block !important;
    text-align: center !important;
    float: none !important;
    .btn {
      margin-bottom: 4px;
    }
    @media screen and (max-width: 768px) {
      .btn {
      margin-top: 4px;
      }
    };
  }
}
</style>
